import {Injectable} from '@angular/core';
import {SwPush} from '@angular/service-worker';
import {WebPushControllerService} from '@api/utisha-backend';
import {NavigationService} from './nav/navigation.service';
import {firstValueFrom} from 'rxjs';
import {logUtishaError} from '../util/log';

@Injectable({
  providedIn: 'root'
})
export class WebPushService {

  readonly VAPID_PUBLIC_KEY = 'BEDxQGQChup0_jzIlCjbN0_MqKw5nFPY8WwfnX2NgHPEu_vmE_DV7tVorhMsAdLQnh6SkN4sTSHuyTTZVV_suQg';

  constructor(private swPush: SwPush,
              private nav: NavigationService,
              private webpushService: WebPushControllerService) {
  }

  public listenToNotificationClicks(): void {
    this.swPush.notificationClicks.subscribe(
      (notification) => this.handleNotification(notification));
  }

  subscribeToNotifications(): Promise<void | PushSubscription> {
    return this.swPush.requestSubscription({
      serverPublicKey: this.VAPID_PUBLIC_KEY
    })
      .then(sub => firstValueFrom(this.webpushService.subscribe(sub as any)).then(() => sub))
      .catch((err: any) => logUtishaError('Could not subscribe to notifications', err));
  }

  private handleNotification({action, notification}: { action: string; notification: any }): void {
    if (!notification || !notification.data || !notification.data.meetingId) {
      return;
    }
    switch (action) {
      case 'go-to-meeting': this.nav.studentEventDetails(notification.data.meetingId);
    }
  }
}
